import type { NotificationSeverity, NotificationType } from '../types/notification.types'

export const NOTIFICATION_ROUTE = '/solutions/wms/general/notifications'

export const NOTIFICATION_BREADCRUMB_ROOT = [{ label: 'WMS', path: '/solutions/wms' }]

export const NOTIFICATION_MESSAGES = {
  subtitle: 'Pemberitahuan tugas dan persetujuan yang perlu Anda tindak lanjuti',
  empty: 'Belum ada notifikasi. Tugas dan persetujuan baru akan muncul di sini.',
  emptyFiltered: 'Tidak ada notifikasi yang cocok dengan filter ini.',
  popoverEmpty: 'Belum ada notifikasi.',
  markedAll: 'Semua notifikasi ditandai sudah dibaca.',
  markedSome: (count: number) => `${count} notifikasi ditandai sudah dibaca.`
} as const

/** Tab GEN-03 (prototype `gen-03.html`): "Untuk Saya" untuk semua role, "Semua Persona" per D5. */
export const NOTIFICATION_TABS = { me: 'Untuk Saya', all: 'Semua Persona' } as const

export type NotificationMeta = { label: string; icon: string }

/** Label & ikon per jenis notifikasi (Bahasa Indonesia, mengikuti istilah modul WMS). */
export const NOTIFICATION_TYPE_META: Record<NotificationType, NotificationMeta> = {
  PR_SUBMITTED: { label: 'PR diajukan', icon: 'tabler:file-description' },
  PR_PENDING_PURCHASING: { label: 'PR menunggu Purchasing', icon: 'tabler:shopping-cart' },
  PR_APPROVED: { label: 'PR disetujui', icon: 'tabler:circle-check' },
  PR_REJECTED: { label: 'PR ditolak', icon: 'tabler:circle-x' },
  ARRIVAL_PALLET_CLOSED: { label: 'Pallet kedatangan ditutup', icon: 'tabler:package-import' },
  TOBACCO_RECEIPT_PENDING: { label: 'Penerimaan tembakau menunggu', icon: 'tabler:leaf' },
  TOBACCO_RECEIPT_STATUS: { label: 'Status penerimaan tembakau', icon: 'tabler:leaf' },
  QC_ASSIGNED: { label: 'Tugas QC', icon: 'tabler:microscope' },
  QC_DRAFT_SUBMITTED: { label: 'Draft QC dikirim', icon: 'tabler:clipboard-check' },
  QC_RETURNED: { label: 'QC dikembalikan', icon: 'tabler:arrow-back-up' },
  PUTAWAY_ASSIGNED: { label: 'Tugas putaway', icon: 'tabler:forklift' },
  REQUEST_SUBMITTED: { label: 'Request material diajukan', icon: 'tabler:clipboard-list' },
  REQUEST_STATUS: { label: 'Status request material', icon: 'tabler:clipboard-list' },
  PICKING_ASSIGNED: { label: 'Tugas picking', icon: 'tabler:hand-grab' },
  RO_PENDING_APPROVAL: { label: 'Return Order menunggu approval', icon: 'tabler:truck-return' },
  RO_STATUS: { label: 'Status Return Order', icon: 'tabler:truck-return' },
  RO_PICKUP_ASSIGNED: { label: 'Tugas pengambilan NG', icon: 'tabler:truck-loading' },
  TRANSFER_PENDING_APPROVAL: { label: 'Transfer menunggu approval', icon: 'tabler:arrows-exchange' },
  TRANSFER_STATUS: { label: 'Status transfer', icon: 'tabler:arrows-exchange' },
  OPNAME_STARTED: { label: 'Stock opname dimulai', icon: 'tabler:list-check' },
  OPNAME_TASK_ASSIGNED: { label: 'Tugas hitung opname', icon: 'tabler:list-check' },
  DISCREPANCY_ESCALATED: { label: 'Selisih dieskalasi', icon: 'tabler:alert-triangle' },
  DISCREPANCY_DECIDED: { label: 'Selisih diputuskan', icon: 'tabler:gavel' },
  CLAIM_SORT_ASSIGNED: { label: 'Tugas sortir claim', icon: 'tabler:sort-ascending' },
  CLAIM_AWAITING_APPROVAL: { label: 'Claim menunggu approval', icon: 'tabler:file-certificate' },
  CLAIM_AUTO_APPROVED: { label: 'Claim disetujui otomatis', icon: 'tabler:clock-check' },
  ALM_REQUEST_CREATED: { label: 'Batch FG menunggu Terima & Cek', icon: 'tabler:package' },
  ALM_PENDING_APPROVAL: { label: 'Batch FG menunggu approval', icon: 'tabler:package' },
  ALM_AUTO_APPROVED: { label: 'Batch FG disetujui otomatis', icon: 'tabler:clock-check' },
  GAB_AUTO_APPROVED: { label: 'Permintaan ALM disetujui otomatis', icon: 'tabler:clock-check' },
  DESTRUCTION_PENDING_APPROVAL: { label: 'Pemusnahan menunggu approval', icon: 'tabler:flame' },
  DESTRUCTION_ASSIGNED: { label: 'Tugas pemusnahan', icon: 'tabler:flame' },
  MOVE_TASK_ASSIGNED: { label: 'Tugas pindah material', icon: 'tabler:transfer' },
  CAPTURE_ASSIGNED: { label: 'Tugas pendataan awal', icon: 'tabler:scan' },
  CAPTURE_STATUS: { label: 'Status pendataan awal', icon: 'tabler:clipboard-check' },
  SYSTEM_INFO: { label: 'Informasi sistem', icon: 'tabler:info-circle' }
}

export const notificationMetaOf = (type: string): NotificationMeta =>
  NOTIFICATION_TYPE_META[type as NotificationType] ?? { label: type, icon: 'tabler:bell' }

export const SEVERITY_TONE: Record<NotificationSeverity, 'info' | 'success' | 'warning' | 'danger'> = {
  info: 'info',
  success: 'success',
  warning: 'warning',
  critical: 'danger'
}

export const SEVERITY_LABEL: Record<NotificationSeverity, string> = {
  info: 'Info',
  success: 'Selesai',
  warning: 'Perlu perhatian',
  critical: 'Kritis'
}

export const STATUS_FILTER_OPTIONS = [
  { value: '', label: 'Semua status' },
  { value: 'unread', label: 'Belum dibaca' },
  { value: 'read', label: 'Sudah dibaca' }
]

export const PERIOD_FILTER_OPTIONS = [
  { value: '', label: 'Semua waktu' },
  { value: 'today', label: 'Hari ini' },
  { value: '7d', label: '7 hari terakhir' },
  { value: '30d', label: '30 hari terakhir' }
]
